export class Bank {
  code: string;
  fullName: string;
  id: string;
  ispb: string;
  shortName: string;

  constructor(data: string | Bank | DjangoBank = {}) {
    if (data instanceof Bank) {
      bindBankData(this, data);
    } else if (typeof data === 'string') {
      bindDjangoBankData(this, { id: data });
    } else {
      bindDjangoBankData(this, data);
    }
  }

  get djangoModel() {
    return getDjangoModel(this);
  }
}

export function parseBank(data?: string | Bank | DjangoBank) {
  if (data) {
    return new Bank(data);
  } else {
    return undefined;
  }
}

function bindBankData(bank: Bank, data: Bank) {
  bank.code = data.code;
  bank.fullName = data.fullName;
  bank.id = data.id;
  bank.ispb = data.ispb;
  bank.shortName = data.shortName;
}

//////////////////////
/// DJANGO SUPPORT ///
//////////////////////
export interface DjangoBank {
  code?: string;
  full_name?: string;
  id?: string;
  ispb?: string;
  short_name?: string;
}

function bindDjangoBankData(bank: Bank, data: DjangoBank) {
  bank.code = data.code;
  bank.fullName = data.full_name;
  bank.id = data.id;
  bank.ispb = data.ispb;
  bank.shortName = data.short_name;
}

function getDjangoModel(bank: Bank) {
  return {
    code: bank.code,
    full_name: bank.fullName,
    id: bank.id,
    ispb: bank.ispb,
    short_name: bank.shortName,
  };
}
